import { memo } from 'react';

function LoadingIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.98">
        <path
          d="M12.4 2.25V4.75M12.4 18V22M6.15002 12H2.65002M21.65 12H20.15M18.8571 18.4571L18.15 17.75M19.0642 5.41579L17.65 6.83M5.3216 19.0784L8.15002 16.25M5.5287 5.20868L7.65002 7.33"
          stroke="#919EAB"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default memo(LoadingIcon);
